import React from "react";
import { Controller } from "react-hook-form";
import get from "lodash/get";
import { StyledTextarea } from "./Textarea.style";
import clsx from "clsx";

const Textarea = (props, ref) => {
  const { name, control, className, ...rest } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState: { errors } }) => {
        const errorMsg = get(errors, `${name}.message`, undefined);

        return (
          <>
            <StyledTextarea
              {...field}
              {...rest}
              //   ref={ref}
              type="text"
              className={`${className} ${clsx({
                "disabled:bg-quartenary disabled:border-quartenary":
                  rest?.disabled,
              })}`}
            />

            {errorMsg ? (
              <label className="label !py-1 text-vekin-message-error">
                <span className="label-text-alt text-vekin-message-error">
                  {errorMsg}
                </span>
              </label>
            ) : null}
          </>
        );
      }}
    />
  );
};

Textarea.displayName = "Textarea";

export default Textarea;
